import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ParamMap, Params } from '@angular/router';
import { map, mergeMap } from 'rxjs/operators';

//Components such as the Nav Header or the Release notes that aren't
//Directly linked to a route are unable to access route params normally.
//So we are going to load the params observable into a service
//So that we can access them elsewhere.

@Injectable({
  providedIn: 'root'
})
export class RouteParamsService {
  private params: Observable<ParamMap>;
  private queryParams: Observable<any>;
  constructor() {}

  setParams(params: Observable<ParamMap>): void {
    this.params = params;
  }

  setQueryParams(params: Observable<ParamMap>): void {
    this.queryParams = params;
  }

  getParam(name: string): Observable<string | null> {
    if (this.params == null) {
      return of(null);
    }
    return this.params.pipe(
      map(params => {
        return params.get(name);
      })
    );
  }

  getQueryParam(name: string): Observable<string | null> {
    if (this.queryParams == null) {
      return of(null);
    }
    return this.queryParams.pipe(
      map(params => {
        return params.get(name);
      })
    );
  }
  isInitialized() {
    return this.params != null;
  }
}
